import FormCreate from './form-create';

export default class QaCreate extends FormCreate
{
    constructor(questionTypeValueToId)
    {
        // call FormCreate constructor
        super(questionTypeValueToId);

        this.updateAllPoints();

        // leave an .points field
        $('form #form-col').on('blur', '.points', (e) => {
            this.blurQaPoints(e);
        });

        // change question to auto fail
        $('form #form-col').on('change', '.additional select', (e) => {
            this.changeAutoFail(e);
        });
    }

    /**
     * blurEditableInput 
     * 
     * When you leave an edittable input fix any n/a points
     *
     * @param {Object} event
     * @return null
     */
    blurEditableInput(event)
    {
        let $input   = $(event.currentTarget);
        let $link    = $input.prev();
        let inputVal = $input.val();

        // Handle an empty input value (we need to show something)
        if (inputVal === '')
        {
            inputVal = '<empty>';
        }

        // Handle N/A, n/a, NA, or na
        if (/^[Nn]\s*\/?\s*[Aa]$/.test(inputVal))
        {
            $input.next('.additional').find('input.points').val('na').prop('readonly', true);
        }
        else
        {
            $input.next('.additional').find('input.points').prop('readonly', false);
        }

        // Make the input we just changed, match the h3 text
        $link.text(inputVal);

        // update the points again
        this.updateAllPoints();
    }

    /**
     * changeAutoFail
     *
     * When you change an auto-fail dropdown option, set points to 0 and disable the points input.
     *
     * @param {Object} event
     * @return null
     */
    changeAutoFail(event)
    {
        let $select  = $(event.currentTarget);
        let selectId = $select.attr('id');
        let value    = $select.find('option:selected').val();

        let $additional = $select.closest('.additional');

        // Change auto fail
        if (/[0-9]-auto_fail$/.test(selectId)) {
            // none
            if (value === 'none') {
                $additional.find('input.points').prop('readonly', false);
            // section/form
            } else {
                $additional.find('input.points').val(0).prop('readonly', true);
            }
        }
    }

    /**
     * addNewSection 
     *
     * @param {jQuery} $addAnchor 
     * @param boolean child
     * @return null
     */
    addNewSection ($addAnchor, child = false)
    {
        let $section = $addAnchor.closest('.form_section');
        let sIndex   = this.getNextSectionIndex();

        let id   = 'form_section-' + sIndex + '-';
        let name = 'form_section[' + sIndex + ']';

        let sectionTemplateSelector = '#section-template';
        if (child)
        {
            sectionTemplateSelector = '#subsection-template';
        }

        let $sectionTemplate = $('#templates > ' + sectionTemplateSelector + ' > div').clone();

        // update index of this section
        $sectionTemplate.attr('data-index', sIndex);

        if (child)
        {
            // set the parent section
            $sectionTemplate.find(sectionTemplateSelector + '-parent').val($section.attr('data-index'));
        }

        // update the ids and names
        $sectionTemplate.find(sectionTemplateSelector + '-name').attr('name', name + '[name]');
        $sectionTemplate.find(sectionTemplateSelector + '-possible-points')
            .attr('id', id + 'possible_points')
            .attr('name', name + '[possible_points]');

        if (child)
        {
            $sectionTemplate.find(sectionTemplateSelector + '-parent')
                .attr('id', id + 'parent')
                .attr('name', name + '[parent]');
        }

        // add the add menu to the section
        let $addBtn = $('#add-button-template > div').clone();
        $sectionTemplate.append($addBtn);

        // add the new section
        if (child)
        {
            $section.append($sectionTemplate);
        }
        else
        {
            $section.after($sectionTemplate);
        }

        // now add a default text question to this section
        let $anchor = $sectionTemplate.find('> .add a[data-type="q-radio"]');
        this.addNewQuestion($anchor);
    }

    /**
     * addNewQuestion 
     * 
     * @param {jQuery} $addAnchor 
     * @return null
     */
    addNewQuestion($addAnchor)
    {
        let type      = $addAnchor.attr('data-type');
        let $question = $addAnchor.closest('.add').prev('.questions');
        let qIndex    = $question.find('> div.mb-4').last().attr('data-index');
        let sIndex    = $question.closest('div.form_section').attr('data-index');

        if (qIndex === undefined)
        {
            qIndex = 0;
        }
        else
        {
            qIndex = parseInt(qIndex) + 1;
        }

        let id   = 'form_section-' + sIndex + '-questions-' + qIndex;
        let name = 'form_section[' + sIndex + '][questions][' + qIndex + ']';

        type = type.slice(2);

        let $questionTemplate   = $('#templates > #question-' + type + '-template > div').clone();
        let $additionalTemplate = $('#templates > #additional-template > div').clone();

        // update index of this question
        $questionTemplate.attr('data-index', qIndex);

        // remove the empty additional area
        $questionTemplate.find('> div.additional').remove();

        // add the additional area to the question
        $questionTemplate.find('> input.editable-input').after($additionalTemplate);

        // update the ids and names
        $questionTemplate.find('> input.editable-input')
            .attr('name', name + '[question]')
            .attr('id', id + '-question');
        $questionTemplate.find('#additional-template-type').val(this.questionTypeValueToId[type]);
        $questionTemplate.find('#additional-template-type-label')
            .attr('for', id + '-type_id')
            .attr('id', '');
        $questionTemplate.find('#additional-template-type')
            .attr('id', id + '-type_id')
            .attr('name', name + '[type_id]');
        $questionTemplate.find('#additional-template-required-label')
            .attr('for', id + '-required')
            .attr('id', '');
        $questionTemplate.find('#additional-template-required')
            .attr('id', id + '-required')
            .attr('name', name + '[required]');

        // handle the response area
        switch (type)
        {
            case 'text':
                $questionTemplate.find('.response > .mb-4 > input')
                    .attr('id', id + '-responses-0-response')
                    .attr('name', name + '[responses][0][response]');
                break;

            case 'textarea':
                $questionTemplate.find('.response > .mb-4 > textarea')
                    .attr('id', id + '-responses-0-response')
                    .attr('name', name + '[responses][0][response]');
                break;

            case 'radio':
            case 'checkbox':
                $questionTemplate.find('.response > .mb-4 > .form-check > input[type=text]').each(function(rIndex) {
                    $(this).attr('id', id + '-responses-' + rIndex + '-response')
                        .attr('name', name + '[responses][' + rIndex + '][response]');
                });

                // add delete option to the responses
                $questionTemplate.find('.response > .mb-4 > .form-check:not(:last-child)').append('<i class="bi-trash-fill"></i>');
                break;
        }

        $questionTemplate.find('.response > .mb-4 .additional #' + type + '-points').each(function(rIndex) {
            $(this).attr('id', id + '-responses-' + rIndex + '-possible_points')
                .attr('name', name + '[responses][' + rIndex + '][possible_points]');
        });
        $questionTemplate.find('.response > .mb-4 .additional #' + type + '-fail').each(function(rIndex) {
            $(this).attr('id', id + '-responses-' + rIndex + '-auto_fail')
                .attr('name', name + '[responses][' + rIndex + '][auto_fail]');
        });

        // add the new question
        $question.append($questionTemplate);

        this.updateAllPoints();
    }

    /**
     * blurQaPoints 
     * 
     * When you leave a .points input, will update all the possible points for
     * the form, section, and question.
     * 
     * @param {Object} event
     * @return null
     */
    blurQaPoints(event)
    {
        this.updateAllPoints();
    }

    /**
     * changeQuestionTypeSelect
     *
     * Change an additional select, check if it's a question type, then make the dom updates
     *
     * @param {Object} event
     * @return null
     */
    changeQuestionTypeSelect(event)
    {
        let $typeSelect = $(event.currentTarget);
        let selectId    = $typeSelect.attr('id');
        let type        = $typeSelect.find('option:selected').attr('data-type');

        let $section = $typeSelect.closest('.form_section');

        // Change question type
        if (/[0-9]-type_id$/.test(selectId))
        {
            let $additional      = $typeSelect.closest('.additional');
            let $responseWrapper = $additional.next('.response').find('.mb-4');
            let $responseInput   = $responseWrapper.find('input[type=text], textarea');

            let responseId   = $responseInput.attr('id');
            let responseName = $responseInput.attr('name');

            // delete the old response
            $responseWrapper.remove();

            // add a new question of the changed type to this section
            let $anchor = $section.find('> .add a[data-type="q-' + type + '"]');

            // this will add the question temporarily to the end of this section, then we move it later
            this.addNewQuestion($anchor);

            let $newQuestionWrapper = $section.find('> .questions').first().find('> .form-component').last();
            let $newResponseWrapper = $newQuestionWrapper.find('.response > .mb-4').last();

            // update the new question's response id/name
            $newResponseWrapper.find('> input, > textarea, > .form-check > input[type=text]').first()
                .attr('id', responseId)
                .attr('name', responseName);

            let additionalId   = responseId;
            let additionalName = responseName;

            additionalId   = additionalId.slice(0, -9);    // remove -response
            additionalName = additionalName.slice(0, -10);  // remove [response]

            // update the new question's additional points/auto-fail id/name
            $newResponseWrapper.find('.additional label[for=' + type + '-points] + input')
                .attr('id', additionalId + '-possible_points')
                .attr('name', additionalName + '[possible_points]');

            $newResponseWrapper.find('.additional label[for=' + type + '-fail] + select')
                .attr('id', additionalId + '-auto_fail')
                .attr('name', additionalName + '[auto_fail]');

            // move the new response to the right spot
            $additional.next('.response').append($newResponseWrapper);

            // delete what's left of the new question
            $newQuestionWrapper.remove();

            // make sure all the additional fields are shown
            $additional.next('.response').find('.additional').show();
        }
    }

    /**
     * clickAddResponseOption 
     *
     * Click on the add response option to a radio or checkbox question.
     * 
     * @param event $event 
     * @return null
     */
    clickAddResponseOption(event)
    {
        let $prevRadioCheck  = $(event.currentTarget).closest('.form-check').prev('.form-check');
        let $wrapper         = $(event.currentTarget).closest('.mb-4');
        let $newRadioCheck   = $prevRadioCheck.clone();

        let id   = $prevRadioCheck.find('> input').last().attr('id');
        let name = $prevRadioCheck.find('> input').last().attr('name');

        // update the index count on the input name
        id   = id.replace(/-(\d+)-response$/, function(full, n) { return '-' + (Number(n) + 1); });
        name = name.replace(/\[(\d+)\]\[response\]$/, function(full, n) { return '[' + (Number(n) + 1) + ']'; });

        $newRadioCheck.find('> input').last()
            .attr('id', id + '-response')
            .attr('name', name + '[response]');

        // handle the additional options
        $newRadioCheck.find('.additional input.points')
            .attr('id', id + '-possible_points')
            .attr('name', name + '[possible_points]');

        $newRadioCheck.find('.additional select.fail')
            .attr('id', id + '-auto_fail')
            .attr('name', name + '[auto_fail]');

        $prevRadioCheck.after($newRadioCheck);
    }

    /**
     * updateAllPoints
     *
     * 1. Update each Question Possible Points
     * 2. Update each Section Possible Points
     * 3. Update each Form Possible Points
     * 4. Add Response Possible Points to each Response
     */
    updateAllPoints()
    {
        // Reset the current form and all section points
        $('#form-possible-points').val(0);
        $('#form-col .section-possible-points').val(0);

        let formPoints     = 0;
        let sectionPoints  = 0;
        let questionPoints = 0;

        // each section
        $('#form-col .form_section').each(function() {
            let $section  = $(this);
            sectionPoints = 0;

            // each question
            $section.find('> .questions > .form-component').each(function() {
                let $question  = $(this);
                questionPoints = 0;

                // each response
                $question.find('input.points').each(function() {
                    let $response      = $(this);
                    let responsePoints = $response.val();

                    if (/^[0-9]+$/.test(responsePoints))
                    {
                        responsePoints = parseInt(responsePoints);

                        // add points to response (ui)
                        let $editable = null;
                        // radio/checkbox
                        if ($response.closest('.additional').closest('.form-check').length) {
                            $editable = $response.closest('.additional').siblings('label.editable').first();

                        // text/textarea
                        } else {
                            $editable = $response.closest('.additional').closest('.response').siblings('h3.editable').first();
                        }

                        let span = document.createElement('span');
                        span.className   = 'ms-2 badge text-bg-secondary';
                        span.textContent = responsePoints;

                        $editable.find('span').remove();
                        $editable.append(span);

                        // Checkbox
                        if ($response.closest('.additional').closest('.form-check').hasClass('checkbox')) {
                            questionPoints += responsePoints;
                        // Radio, text, textare
                        } else {
                            // save the highest points for this question
                            if (responsePoints > questionPoints)
                            {
                                questionPoints = responsePoints;
                            }
                        }
                    }
                });

                sectionPoints += questionPoints;
                formPoints    += questionPoints;
            });

            // Update Section Possible Points
            $section.find('> .form_section_wrapper input.section-possible-points').val(sectionPoints);
        });

        // Update Form Possible Points
        $('#form-possible-points').val(formPoints);
    }
}
